module.exports = __webpack_public_path__ + "static/media/URL.986cbdb3.svg";